import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import routes from 'router/routes';

export function useThirdPartyScripts() {
  const location = useLocation();
  const [shouldLoadThirdParties, setShouldLoadThirdParties] = useState(false);

  useEffect(() => {
    const isPaymentPage =
      routes.PARKING_PIP === location.pathname ||
      routes.LOUNGES_PIP === location.pathname ||
      routes.EURAIL_PIP === location.pathname;

    setShouldLoadThirdParties(!isPaymentPage);

    if (isPaymentPage) {
      // Remove injected third-party scripts
      const scriptSelectors = ['script[src*="googletagmanager"]', 'script[src*="gtag/js"]'];
      scriptSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => el.remove());
      });

      // Remove global objects
      delete (window as any).gtag;
      delete (window as any).dataLayer;
    }
  }, [location.pathname]);

  return shouldLoadThirdParties;
}
